/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_select_1 = __importStar(require("react-select"));

var classnames_1 = __importDefault(require("classnames"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var CaretDownIcon = function CaretDownIcon() {
  return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faChevronCircleDown
  });
};

var DropdownIndicator = function DropdownIndicator(props) {
  var isFocused = props.isFocused;
  var icon = isFocused ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faChevronCircleUp
  }) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, {
    icon: free_solid_svg_icons_1.faChevronCircleDown
  });
  return react_1.default.createElement(react_select_1.components.DropdownIndicator, Object.assign({}, props), icon);
};

var Select = function Select(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      isSearchable = _ref.isSearchable,
      name = _ref.name,
      placeholder = _ref.placeholder,
      style = _ref.style;

  var handleChange = function handleChange(value) {
    if (onChange) {
      onChange(value);
    }
  };

  return react_1.default.createElement("div", {
    className: "Select__container ".concat(classnames_1.default(className))
  }, react_1.default.createElement(react_select_1.default, {
    className: "react-select",
    classNamePrefix: "react-select",
    value: value,
    name: name,
    isSearchable: isSearchable,
    onChange: handleChange,
    options: options || [],
    placeholder: placeholder,
    components: {
      DropdownIndicator: DropdownIndicator
    },
    styles: {
      control: function control(provided, state) {
        return function () {
          return Object.assign(Object.assign({}, provided), style);
        };
      }
    }
  }));
};

exports.default = Select;